import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../styles/encuesta4c.module.css";

const KEYS = [0, 1, 2, 3, 4, 5, 6];

export default function SurveyKeyboardHint({ visible, hiding }) {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <div
      className={`${styles.keyboardHint} ${hiding ? styles.keyboardHintHide : ""}`}
      role="note"
      aria-live="polite"
    >
      <p className={styles.keyboardHintText}>{t("keyboard.hint")}</p>
      <div className={styles.keyboardKeys}>
        {KEYS.map((n) => (
          <span key={n} className={styles.keyboardKey}>
            {n}
          </span>
        ))}
        <span className={`${styles.keyboardKey} ${styles.keyboardKeyEnter}`}>
          {t("keyboard.enter")}
        </span>
      </div>
    </div>
  );
}
